// Copyright (c) 2016 Deere & Company

import DuplicatePinPlateRequest from './duplicate-pin-plate-request';
import actionCreators from '../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    ...state.duplicatePinPlateRequest
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const queryParams = parentProps.routeParams;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        queryParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(DuplicatePinPlateRequest);



// WEBPACK FOOTER //
// ./src/product/duplicate-pin-plate/components/index.js